import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoTitle from 'eco-design/base/eco-title';
import EcoUserStoriesCard from 'eco-design/sections/eco-userstories-card';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('delta3Plus.Users');
    const items = [
        {
            desc: t('item1.desc'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
            pc: '//au.ecoflow.com/cdn/shop/files/FotoJet_1.jpg',
        },
        {
            desc: t('item2.desc'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747125119485/output.png',
        },
    ];

    return (
        <div className={styles.comp} id="Users">
            <EcoTitle title={t('title')} />
            <EcoSpaceSmall />
            <EcoUserStoriesCard items={items} />
            <EcoSpace />
        </div>
    );
}
